<template>
  <el-dialog
      :title="'编辑'+year+'年度收费情况'"
      :visible.sync="situationDialog"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
      width="1200px"
      center>
    <el-form :model="situationForm" ref="situationForm" label-width="150px">
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="社区：" prop="project">
            <el-input :value="project" readonly placeholder="请输入社区"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="小区：" prop="community">
            <el-input :value="community" readonly placeholder="请输入小区"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="楼门户：" prop="room">
            <el-input :value="room" readonly placeholder="请输入楼门户"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="户主姓名：" prop="name">
            <el-input :value="name" readonly placeholder="请在居民数据中修改"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="收费年度：" prop="year">
            <el-input :value="year + '年度'" readonly></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="应收物业费：" prop="YJWuYeFei">
            <el-input v-model="situationForm.YJWuYeFei" type="number" placeholder="请输入应收物业费"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="实收物业费：" prop="SjWuYeFei">
            <el-input v-model="situationForm.SjWuYeFei" type="number" placeholder="请输入实收物业费"></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item label="应收保安费：" prop="YJBaoAnFei">
            <el-input v-model="situationForm.YJBaoAnFei" type="number" placeholder="请输入应收保安费"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="实收保安费：" prop="SjBaoAnFei">
            <el-input v-model="situationForm.SjBaoAnFei" type="number" placeholder="请输入实收保安费"></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item label="应收卫生费：" prop="YJWeiShengFei">
            <el-input v-model="situationForm.YJWeiShengFei" type="number" placeholder="请输入应收物业费"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="实收卫生费：" prop="SjweishengFei">
            <el-input v-model="situationForm.SjweishengFei" type="number" placeholder="请输入实收物业费"></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item label="应收停车管理费：" prop="YJTingCheGuanLiFei">
            <el-input v-model="situationForm.YJTingCheGuanLiFei" type="number" placeholder="请输入应收物业费"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="实收停车管理费：" prop="SjTingCheGuanLiFei">
            <el-input v-model="situationForm.SjTingCheGuanLiFei" type="number" placeholder="请输入实收物业费"></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item label="应收垃圾清运费：" prop="YJLaJiQingYunFei">
            <el-input v-model="situationForm.YJLaJiQingYunFei" type="number" placeholder="请输入应收物业费"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="实收垃圾清运费：" prop="SjLaJiQingYunFei">
            <el-input v-model="situationForm.SjLaJiQingYunFei" type="number" placeholder="请输入实收物业费"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row v-for="(item,index) in situationForm.otherDeiYong" :key="index">
        <el-col :span="12">
          <el-form-item :label="'应收' + item.name + ':'" prop="yinjiao">
            <el-input v-model="item.yinjiao" type="number" :placeholder="'请输入'+item.name"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="10">
          <el-form-item :label="'实收' + item.name + ':'" prop="shijiao">
            <el-input v-model="item.shijiao" type="number" :placeholder="'请输入'+item.name"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="2" class="flex align-center justify-around">
          <el-button type="primary" @click="deleteItem(index)" size="medium"><i class="el-icon-delete font-size-lg"></i>
          </el-button>
        </el-col>
      </el-row>
      <div class="flex align-center justify-around margin-bottom">
        <el-button type="primary" @click="addIitem">+ 添加其他收费项</el-button>
      </div>

      <el-form-item class="flex align-center justify-around" label-width="0">
        <el-button class="padding-lr-xl" @click="resetForm('situationForm')">取消</el-button>
        <el-button class="padding-lr-xl" type="primary" @click="submitForm('situationForm')">提交</el-button>
      </el-form-item>
    </el-form>
  </el-dialog>
</template>

<script>
import {optionList, year} from "@/utils/utils";
import {wuYeQingKuangShow, wuYeQingKuangUpdate} from "@/api/property";

export default {
  name: "situationDialog",
  props: {
    situationDialog: {
      type: Boolean,
      default: false
    },
    year: {
      type: Number,
    },
    setId: {
      type: Number,
      default() {
        return 0;
      }
    },
    setItem: {
      type: Object
    }
  },
  data() {
    return {
      yearList: optionList(true, year),
      project: '',
      community: '',
      room: '',
      name: '',
      situationForm: {
        YJWuYeFei: '',
        SjWuYeFei: '',
        YJBaoAnFei: '',
        SjBaoAnFei: '',
        YJWeiShengFei: '',
        SjweishengFei: '',
        YJTingCheGuanLiFei: '',
        SjTingCheGuanLiFei: '',
        YJLaJiQingYunFei: '',
        SjLaJiQingYunFei: '',
        otherDeiYong: []
      },
    }
  },
  computed: {
    user() {
      return this.$store.state.user
    }
  },
  methods: {
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.$emit('cancelDialog', false)
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.submitData(formName)
        }
      });
    },
    async submitData(formName) {
      if (this.situationForm.otherDeiYong.length > 0) {
        this.situationForm.otherDeiYong.map(item => {
          if (item.yinjiao) item.yinjiao = Number(item.yinjiao).toFixed(2)
          if (item.shijiao) item.shijiao = Number(item.shijiao).toFixed(2)
        })
      }
      let _state = await wuYeQingKuangUpdate(
          this.setId,
          this.year,
          this.situationForm.YJWuYeFei,
          this.situationForm.SjWuYeFei,
          this.situationForm.YJBaoAnFei,
          this.situationForm.SjBaoAnFei,
          this.situationForm.YJWeiShengFei,
          this.situationForm.SjweishengFei,
          this.situationForm.YJTingCheGuanLiFei,
          this.situationForm.SjTingCheGuanLiFei,
          this.situationForm.YJLaJiQingYunFei,
          this.situationForm.SjLaJiQingYunFei,
          JSON.stringify(this.situationForm.otherDeiYong)
      );
      this.$message.success(_state.info);
      this.$refs[formName].resetFields();
      this.$emit("cancelDialog", true);
    },
    //  删除收费项
    deleteItem(index) {
      this.$confirm('您确定要删除该收费项吗？', '温馨提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.situationForm.otherDeiYong.splice(index, 1)
      })
    },
    // 添加收费项
    addIitem() {
      this.$prompt('请输入费用项名称', '费用项添加', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
      }).then(({value}) => {
        if (value) {
          this.situationForm.otherDeiYong.push(
              {name: value, yinjiao: '', shijiao: '',}
          )
        }
      })

    },
    //  获取收费内容
    async getCarge() {
      let _data = await wuYeQingKuangShow(this.setId, this.year)
      this.situationForm = {
        YJWuYeFei: _data.data.yj_wuyefei,
        SjWuYeFei: _data.data.sj_wuyefei,
        YJBaoAnFei: _data.data.yj_baoanfei,
        SjBaoAnFei: _data.data.sj_baoanfei,
        YJWeiShengFei: _data.data.yj_weishengfei,
        SjweishengFei: _data.data.sj_weishengfei,
        YJTingCheGuanLiFei: _data.data.yj_tingcheguanlifei,
        SjTingCheGuanLiFei: _data.data.sj_tingcheguanlifei,
        YJLaJiQingYunFei: _data.data.yj_lajiqingyunfei,
        SjLaJiQingYunFei: _data.data.sj_lajiqingyunfei,
        otherDeiYong: _data.data.other_feiyong ? JSON.parse(_data.data.other_feiyong) : []
      }
    }
  },
  watch: {
    setItem() {
      this.project = this.setItem.xiangmu_name
      this.community = this.setItem.xiaoqu_name
      this.room = this.setItem.building_name + '-' + this.setItem.element_name + '-' + this.setItem.room_name
      this.name = this.setItem.huzu_name
    },
    situationDialog() {
      if (this.situationDialog) this.getCarge()
    }
  }
}
</script>

<style scoped lang="scss">

</style>